import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'giro-react-toolkit/source/Translation';

import CensusStats from 'CensusStats';
import Legend from 'Legend';

import "./CommuteTimes.scss";

import arrow from "../images/dropdown-arrow.svg";

/**
 * Component that shows commute times. Includes a legend for commute time list
 * and some statistics for selected commute time.
 * Statistic are shown on demand and can be disabled in config
 */
class CommuteTimes extends Component {
   constructor(props) {
      super(props);
      this.state = { commuteTimeIndex: null };

      this.showStatistics = this.showStatistics.bind(this);
      this.hideStatistics = this.hideStatistics.bind(this);
      this.canShowStatistics = ((reachMap.census.enabled) && (reachMap.census.statisticTypes) && (reachMap.census.statisticTypes.length > 0));
   }

   componentDidUpdate(prevProps) {
      // If props have changed, fetch new censusData
      if (this.props.isochroneParam.selectedLocation.latitude !== prevProps.isochroneParam.selectedLocation.latitude ||
         this.props.isochroneParam.selectedLocation.longitude !== prevProps.isochroneParam.selectedLocation.longitude ||
         this.props.isochroneParam.selectedDay !== prevProps.isochroneParam.selectedDay ||
         this.props.isochroneParam.selectedTime !== prevProps.isochroneParam.selectedTime ||
         this.props.isochroneParam.selectedDur !== prevProps.isochroneParam.selectedDur) {
         this.hideStatistics();
      }
   }

   /**
    * Hides the statistics panel
    * */
   hideStatistics() {
      this.setState({ commuteTimeIndex: null });
   }

   /**
    * Shows the statistics panel
    * */
   showStatistics(index) {
      this.setState({ commuteTimeIndex: index });
   }

   render() {

      return (
         <React.Fragment>
            <Legend totalDur={this.props.isochroneParam.selectedDur} canSelectItem={this.canShowStatistics} selectedTimeIndex={this.state.commuteTimeIndex} onCommuteTimeSelected={this.showStatistics} />
            {
               this.state.commuteTimeIndex !== null &&
               <React.Fragment>
                  <CensusStats selectedTimeIndex={this.state.commuteTimeIndex} isochroneParam={this.props.isochroneParam} />
                  <button className="btn-hide-stats" onClick={this.hideStatistics}>
                     <div className="btn-hide-stats__content">
                        <Translation resourceKey="ReachMapRes.HideStatsButtonText" />
                        <img className="btn-hide-stats__icon" src={arrow} />
                     </div>
                  </button>
               </React.Fragment>
            }
            {
               this.state.commuteTimeIndex === null &&
               this.canShowStatistics &&
               <button className="btn-show-stats" onClick={() => this.showStatistics(0)}>
                  <div className="btn-show-stats__content">
                     <Translation resourceKey="ReachMapRes.ShowStatsButtonText" />
                     <img className="btn-show-stats__icon" src={arrow} />
                  </div>
               </button>
            }
         </React.Fragment>
      );
   }
}

CommuteTimes.propTypes = {
   /**
    * Isochrone parameters
    */
   isochroneParam: PropTypes.object
}

export default CommuteTimes;
